export default __webpack_public_path__ + "static/media/messageIcon.dc913953.svg";